import React from 'react';
import { cn } from 'utils';
import { TimelinePositionHitspace } from './TimelinePositionHitspace';
import { TimelinePositionMarker } from './TimelinePositionMarker';

/**
 * The main container for the actual timeline UI
 */
export function Timeline({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}): React.ReactElement {
  return (
    <div
      className={cn(
        'odin-flex',
        'odin-flex-col',
        'odin-gap-2',
        'odin-relative',
        className,
      )}
    >
      {children}
      <TimelinePositionHitspace>
        <TimelinePositionMarker />
      </TimelinePositionHitspace>
    </div>
  );
}
